import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-download-charts-pdf-snackbar',
  template: `
    <section
      class="max-w-xs min-w-[260px] overflow-hidden rounded-lg bg-gray-900 shadow-[0_8px_24px_rgba(0,0,0,0.25)]"
      role="status"
      aria-live="polite"
    >
      <div class="flex items-center gap-3 px-4 py-3">
        <mat-spinner [diameter]="20" color="accent"></mat-spinner>
        <div class="min-w-0 flex-1">
          <h3
            class="m-0 truncate text-sm leading-tight font-semibold text-white"
          >
            {{ message }}
          </h3>
          <p class="m-0 mt-0.5 truncate text-xs leading-tight text-gray-400">
            {{ details }}
          </p>
        </div>
      </div>
      <div class="h-[3px] w-full animate-pulse bg-blue-700"></div>
    </section>
  `,
  standalone: false,
})
export class DownloadChartsPdfSnackbarComponent {
  @Input() message = 'Generating Operations PDF...';

  @Input() details = 'Processing Charts...';
}
